import { FieldRenderProps } from 'react-final-form';
import FormControl, { FormControlProps } from '@material-ui/core/FormControl';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';
import { FormHelperText, TextField, makeStyles, Theme } from '@material-ui/core';
import * as React from 'react';
import { DateTime } from 'luxon';
import { TextFieldProps } from '@material-ui/core/TextField';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

const textFieldStyles = makeStyles((theme: Theme) => ({
    dateControlRoot: {
        width: '100%'
    },
    synthDisabled: {
        '& > div': {
            color: 'inherit !important' as any,
            cursor: 'pointer !important'
        },
        '& > div:before': {
            borderBottomStyle: 'solid !important' as any
        },
        '& > div > input': {
            cursor: 'pointer !important'
        }
    }
 }));


// const StyledTextField = withStyles(textFieldStyles, { name: 'TextField' })(TextField);

export const NoKeyboardTextField: React.FunctionComponent<TextFieldProps> = (props) => {

    const classes = textFieldStyles();

    return <TextField
        {...props}
        disabled={true}
        className={props.disabled ? undefined : classes.synthDisabled}
        // InputProps={inputOverrideClassess}
    />
}

interface IDatePickerWrapperProps extends FieldRenderProps<any, any> {
    label?: string;
    formControlProps?: FormControlProps;
    includeOffset?: boolean;
    isUTCDate?: boolean;
    removeTime?: boolean;
}

const DatePickerWrapper: React.FunctionComponent<IDatePickerWrapperProps> = ({
    input: { name, value, onChange: onInputChange, ...restInput },
    meta,
    onChange,
    label,
    formControlProps,
    format,
    includeOffset,
    isUTCDate,
    removeTime,
    ...rest
}) => {
    const [pickerDialogOpen, setPickerDialogOpen] = React.useState(false);
    const showError = meta.touched && (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) && !meta.submitting;
    const classes = textFieldStyles();
    const includeOffsetsetResolved = includeOffset === true;
    const isUTCDateResolved = isUTCDate === true;
    const removeTimeResolved = removeTime === true;

    let parsedDate: DateTime | null = DateTime.fromISO(value);

    if (!parsedDate.isValid) {
        parsedDate = null;
    }

    const onChangeCombined = React.useCallback((date: MaterialUiPickersDate) => {
        if (onChange) {
            onChange(date);
        }

        let convertedDate = null;

        if (removeTimeResolved) {
            convertedDate = isUTCDateResolved ?
                date?.toUTC().toISODate() :
                date?.toISODate();
        }
        else {
            convertedDate = isUTCDateResolved ?
                date?.toUTC().toISO({ includeOffset: includeOffsetsetResolved }) :
                date?.toISO({ includeOffset: includeOffsetsetResolved });
        }

        onInputChange(convertedDate);
    }, [includeOffsetsetResolved, isUTCDateResolved, onChange, onInputChange, removeTimeResolved]);

    const onClick = React.useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (rest.disabled) {
            return;
        }
        else {
            setPickerDialogOpen(!pickerDialogOpen);
        }
    }, [setPickerDialogOpen, pickerDialogOpen, rest.disabled]);

    const onClose = React.useCallback(() => {
        setPickerDialogOpen(false);
    }, []);

    return (
        <FormControl {...formControlProps} error={showError} className={classes.dateControlRoot}>

            <MuiPickersUtilsProvider utils={LuxonUtils}>
                <KeyboardDatePicker
                    {...rest}
                    name={name}
                    value={parsedDate}
                    label={label}
                    format={format === undefined ? 'dd/MM/yyyy' : format}
                    onChange={onChangeCombined}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    inputProps={restInput}
                    autoComplete="off"
                    TextFieldComponent={NoKeyboardTextField}
                    onClick={onClick}
                    open={pickerDialogOpen}
                    onClose={onClose}
                />
            </MuiPickersUtilsProvider>

            {showError &&
                <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
            }
        </FormControl>
    );
};

export default DatePickerWrapper;